'use server';

import { cookies } from 'next/headers';
import { revalidatePath } from 'next/cache';
import { routing, type Locale } from '@/i18n/routing';
import { createSupabaseServerClient } from '@/lib/supabase/server';

// Server Action invoquée par `LocaleSwitcher` : persiste la locale dans le cookie
// `NEXT_LOCALE` (lu par next-intl à la requête suivante) et invalide le cache
// pour forcer un re-render avec le nouveau dictionnaire. Si l'utilisateur est
// authentifié, on synchronise aussi `raw_user_meta_data.locale` pour que les
// emails GoTrue (reset password, change email…) soient dans la bonne langue.
export async function setLocaleAction(locale: Locale): Promise<void> {
  if (!routing.locales.includes(locale)) return;
  const store = await cookies();
  store.set('NEXT_LOCALE', locale, {
    sameSite: 'lax',
    path: '/',
    // 1 an — la persistance n'est pas considérée comme sensible.
    maxAge: 60 * 60 * 24 * 365,
  });

  const supabase = await createSupabaseServerClient();
  const {
    data: { user },
  } = await supabase.auth.getUser();
  if (user && (user.user_metadata as { locale?: Locale } | null)?.locale !== locale) {
    await supabase.auth.updateUser({ data: { locale } }).catch(() => undefined);
  }

  revalidatePath('/', 'layout');
}
